// Panel header'ındaki mağaza aksiyonları: sepet ikonu + adet rozeti ve "İlan Ver" (mağazadaki
// butonun aynısı). Sıra: bildirimler · sepet · İlan Ver · profil. Mağaza header'ı kaldırıldığı
// için bunlar panelin kendi header'ında durur; yalnız mağazaya erişen roller (müşteri, merchant) görür.
import React from "react";
import { Link } from "react-router-dom";
import { useStoreSepetSayisi } from "../StoreContext";
import { storePath } from "./StoreShared";

export default function HeaderStoreActions() {
  const cartCount = useStoreSepetSayisi(); // FE-89: tam bağlam yerine yalnız adet
  return (
    <span className="store-tokens header-store-actions">
      <Link
        className="header-store-sepet"
        to={storePath("sepet")}
        aria-label={cartCount ? `Sepetim, ${cartCount} ürün` : "Sepetim"}
        title="Sepetim"
      >
        <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="9" cy="20" r="1.5" />
          <circle cx="18" cy="20" r="1.5" />
          <path d="M2 3h3l2.6 11.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 7H6" />
        </svg>
        {cartCount > 0 ? <span className="header-store-sepet__rozet">{cartCount > 99 ? "99+" : cartCount}</span> : null}
      </Link>
      <Link className="st-btn st-btn--ikincil header-store-ilan" to={storePath("ilan-ver")}>
        Eşyanı Sat
      </Link>
    </span>
  );
}
